// @flow

import type { SetupState, SetupAction } from 'stores/flow-type/setup.type';

import {
  AUTO_SETUP_THEME_REQUEST,
  AUTO_SETUP_THEME_SUCCESS,
  AUTO_SETUP_THEME_FAILURE,
  SETUP_FEEDBACK_REQUEST,
  SETUP_FEEDBACK_SUCCESS,
  SETUP_FEEDBACK_FAILURE,
  GET_UPGRADE_THEME_STATUS_REQUEST,
  GET_UPGRADE_THEME_STATUS_SUCCESS,
  GET_UPGRADE_THEME_STATUS_FAILURE,
  RESET_SETUP_FEEDBACK,
  RESET_UPGRADE_THEME_STATUS
} from 'stores/flow-type/setup.type';

const initialState: SetupState = {
  autoSetupThemeLoading: false,
  autoSetupThemeSuccess: false,
  setupFeedbackLoading: false,
  setupFeedbackSuccess: false,
  getUpgradeThemeStatusLoading: false,
  getUpgradeThemeStatusSuccess: false,
  error: undefined,
  code: 0,
  status: '',
  copyProcess: 0,
  setupThemeProcess: 0,
  copyAssetsProgress: '',
  themeUpgradeStatus: '',
  updatedAt: 0,
  themeId: '',
  themeName: ''
};

const setupReducers = (state: SetupState = initialState, action: SetupAction) => {
  switch (action.type) {
    case AUTO_SETUP_THEME_REQUEST:
      return { ...state, autoSetupThemeLoading: true };
    case SETUP_FEEDBACK_REQUEST:
      return { ...state, setupFeedbackLoading: true };
    case AUTO_SETUP_THEME_SUCCESS: {
      const { data } = action.payload;
      const { code, status } = data;
      return {
        ...state,
        autoSetupThemeLoading: false,
        autoSetupThemeSuccess: true,
        error: undefined,
        code,
        status
      };
    }
    case SETUP_FEEDBACK_SUCCESS: {
      return {
        ...state,
        setupFeedbackLoading: false,
        setupFeedbackSuccess: true,
        error: undefined
      };
    }
    case AUTO_SETUP_THEME_FAILURE:
      return {
        ...state,
        autoSetupThemeLoading: false,
        autoSetupThemeSuccess: false,
        error: action.payload
      };
    case SETUP_FEEDBACK_FAILURE:
      return {
        ...state,
        setupFeedbackLoading: false,
        setupFeedbackSuccess: false,
        error: action.payload
      };
    case RESET_SETUP_FEEDBACK:
      return {
        ...state,
        setupFeedbackLoading: false,
        setupFeedbackSuccess: false,
        error: undefined
      };
    case GET_UPGRADE_THEME_STATUS_REQUEST:
      return { ...state, getUpgradeThemeStatusLoading: true, getUpgradeThemeStatusSuccess: false };
    case GET_UPGRADE_THEME_STATUS_SUCCESS: {
      const { data } = action.payload;
      const { copyAssetsProgress, setupProgress, status, updatedAt, themeName, themeId } = data;

      const ratioMap = {
        copyProcess: 80,
        setupThemeProcess: 20
      };

      let { copyProcess = 0, setupThemeProcess = 0 } = state;
      copyProcess =
        copyAssetsProgress === 'running'
          ? copyProcess + (ratioMap.copyProcess - copyProcess) * Math.random() * Math.random() * 0.1
          : copyAssetsProgress === 'done'
          ? ratioMap.copyProcess
          : copyProcess;

      setupThemeProcess =
        setupProgress === 'running'
          ? setupThemeProcess +
            (ratioMap.setupThemeProcess - setupThemeProcess) * Math.random() * Math.random() * 0.1
          : setupProgress === 'done'
          ? ratioMap.setupThemeProcess
          : setupThemeProcess;

      return {
        ...state,
        getUpgradeThemeStatusLoading: false,
        getUpgradeThemeStatusSuccess: true,
        error: undefined,
        copyProcess,
        setupThemeProcess,
        copyAssetsProgress,
        themeUpgradeStatus: status,
        updatedAt,
        themeId,
        themeName
      };
    }
    case GET_UPGRADE_THEME_STATUS_FAILURE:
      return {
        ...state,
        getUpgradeThemeStatusLoading: false,
        getUpgradeThemeStatusSuccess: false,
        error: action.payload
      };
    case RESET_UPGRADE_THEME_STATUS:
      return {
        ...state,
        getUpgradeThemeStatusLoading: false,
        getUpgradeThemeStatusSuccess: false,
        error: undefined,
        copyProcess: 0,
        setupThemeProcess: 0,
        copyAssetsProgress: '',
        themeUpgradeStatus: '',
        updatedAt: 0,
        themeId: '',
        themeName: ''
      };
    default:
      return state;
  }
};
export default setupReducers;
